export default "__VITE_ASSET__9fb28e6c__"